import type { IdentityStatus, ImageQualityStatus } from './types';

/** Mutually exclusive operator review categories; never changes card authority. */
export type CardReviewState = 'ready' | 'awaiting-images' | 'image-issues' | 'completed';

/** Minimal structural input shared by catalog cards and storage projections. */
export interface CardReviewStateInput {
  identityStatus?: IdentityStatus;
  identity?: unknown;
  imageQualityStatus?: ImageQualityStatus;
  reviewChecklistSelection?: { requiresReview?: boolean };
  pendingImageReplacement?: unknown;
}

export function classifyCardReviewState(card: CardReviewStateInput): CardReviewState {
  if (card.imageQualityStatus === 'REJECTED' || card.pendingImageReplacement !== undefined) {
    return 'image-issues';
  }
  if (card.reviewChecklistSelection?.requiresReview) return 'ready';
  if (
    card.identityStatus === 'IDENTIFIED' &&
    card.identity !== undefined &&
    card.identity !== null
  ) {
    return card.imageQualityStatus === 'ACCEPTED' ? 'completed' : 'awaiting-images';
  }
  return 'ready';
}
